<!-- Classes necesarias para pintar el componente "mediano" o "pequeño"(para pocas opciones, menos de 4), y si se requiere centrar el texto de las opciones ->  
	  cssClass: "select-mobile-modal-standar center-select-items"
	  o cssClass: "select-mobile-modal-small center-select-items"
 -->
 <ion-header translucent>
  <ion-toolbar mode="md">
    <ion-title class="font-semibold text-sm">{{title}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content >
	<ion-list>
		<ion-item
			class="font-normal text-sm"
			*ngFor="let option of optionsList"
			(click)="onSelectedOption(option)"
			[button]="true"
			[detail]="false"
			mode="md"
			>
			<ion-label>{{ option }}</ion-label>
		</ion-item>
	</ion-list>
</ion-content>
